import { identity } from "lodash-es";

import {
    CalculatorConfig,
    CalculatorSchema,
    CalculatorVariantFactory,
    CalculatorVariants
} from "../calculator.types";

export const createConfig = <TSchema extends CalculatorSchema>(
    config: Omit<CalculatorConfig<TSchema>, "variants"> & {
        variants: (props: {
            variant: CalculatorVariantFactory<TSchema>;
        }) => CalculatorVariants<TSchema>;
    }
) => {
    return {
        ...config,
        // Using a function to declare the variants ensures the types are correctly inferred.
        // This isn't possible if variants are declared as a static array.
        variants: config.variants({ variant: identity })
    };
};
